import { emojis } from '../assets' 
import { Constants } from '../constants';
import { ChatLocalMesage, ChatMessage, MessageReaction } from '../types';

export const DEFAULT_REACTIONS = [
  getReaction('👍'),
  getReaction('❤️'),
  getReaction('😂'),
  getReaction('😮'),
  getReaction('😢'),
  getReaction('🙏'),
];

export function getReaction(emoji: string) {
  return emojis.find(reaction => reaction.emoji === emoji)
}

export function getReactionByAlias(alias: string) {
  return emojis.find(reaction => reaction.aliases?.includes(alias))
}

export function getReactionType(emoji: string) {
  return getReaction(emoji)?.aliases?.[0]
}


export function getReactionEmoji(emoji: string) {
  return emoji || emojis.find(reaction => reaction.aliases?.includes(emoji))?.emoji
}

export function getReactionsTotalCount(reactionCounts: ChatMessage['message']['reaction_counts']) {
  return (reactionCounts ? Object.values(reactionCounts).reduce((a, b) => a + b, 0) : 0) as unknown as number
}

export function searchEmojis(query: string) {
  const lowerQuery = query.toLowerCase()

  const result = emojis.filter(e => 
    e.description.includes(lowerQuery) ||
    e.category.includes(lowerQuery) ||
    e.aliases.some(a => a.includes(lowerQuery)) ||
    e.tags.some(t => t.includes(lowerQuery))
  )

  return result
}

export function getLatestReactions(message: Pick<ChatLocalMesage, 'latest_reactions' | 'reaction_counts'>) {
  const reactionsObject = message?.reaction_counts
  const latestReactions = message?.latest_reactions || []
  return latestReactions?.length > 0 ? latestReactions : reactionsObject ? Object.keys(reactionsObject).map(key => ({ type: key })) : []
}

/** Returns `true` when `reaction` was posted by `currentUserId`. Safe to call with a falsy id. */
export function isOwnReaction(reaction: MessageReaction, currentUserId: string | undefined): boolean {
  if (!currentUserId) return false
  const reactionUserId = reaction?.user?.id || reaction?.user_id
  return currentUserId === reactionUserId
}

export function formatReactions(reactions: MessageReaction[], maxReactions = Constants.maxReactionsToShow) {
  if (!reactions || reactions.length === 0) return []

  const unique: MessageReaction[] = []
  const seen = new Set<string>()

  for (let i = 0; i < reactions.length && unique.length < maxReactions; i++) {
    const r = reactions[i]
    const key = r?.emoji_code || r?.type || ''
    if (!key) continue
    if (seen.has(key)) continue
    seen.add(key)
    unique.push(r)
  }

  return unique
}